import React from 'react'
import { ReactComponent as FinalBitLogo } from '../../assets/icons/logo.svg'
import styles from './Preloader.module.scss'

/** What the screen says while it has nothing more specific to report. */
export const DEFAULT_MESSAGE = 'Studio Is Loading...'

/**
 * The studio's full-screen waiting state.
 *
 * Drawn to match the static boot screen in `public/index.html` exactly — same
 * background, mark, type and wipe — so that when React mounts on top of it and
 * the boot screen fades out, nothing on screen moves. Change one and you must
 * change the other.
 *
 * Two things here are load-bearing and easy to undo by accident:
 *
 * - The logo is a local SVG inlined into the bundle. It used to be a PNG from
 *   the CDN, so the text rendered instantly and the mark landed a second or
 *   more later — a half-drawn screen on exactly the slow connections this is
 *   for.
 * - The background is opaque and set here. Without it the screen inherited
 *   whatever surface it happened to land on, which is why the same component
 *   read as a dark screen on `/auth/callback` and a near-invisible light one on
 *   `/logout`.
 *
 * `message` lets a caller narrate a longer wait — sign-out saving unsynced work,
 * say — instead of leaving the visitor on a generic "loading" while something
 * specific happens.
 */
const Preloader = ({ message = DEFAULT_MESSAGE }) => {
  return (
    <div className={styles.screen} role='status' aria-live='polite'>
      <FinalBitLogo className={styles.logo} aria-hidden='true' focusable='false' />
      <p className={styles.loader}>{message}</p>
    </div>
  )
}

export default Preloader
